import React, { useState, useEffect } from "react";
import GerarModalResponsivo from "../GerarModalResponsivo";
import { useApi } from "../../contexts/api";
import ModalInformativo from "../ModalInformativo";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/auth";

export default function ModalNotificacao() {
  const { get, post, put } = useApi();
  const { dadosAuth } = useAuth();
  const [abrirModal, setAbrirModal] = useState(false);
  const [urlsBucket, setUrlsBucket] = useState({});
  const [notificacoes, setNotificacoes] = useState([]);
  const [indexNotificacao, setIndexNotificacao] = useState(0);
  const [pausarRotacao, setPausarRotacao] = useState(false);

  useEffect(() => {
    const cookieExibir = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`notificacaoLogadoExibir=`));

    const deveExibirModal = cookieExibir === undefined || cookieExibir.split("=")[1] === "false";

    if (deveExibirModal) {
      buscarNotificacao();
    }
  }, []);

  useEffect(() => {
    if (!abrirModal || pausarRotacao || notificacoes.length <= 1) {
      return undefined;
    }

    const intervalo = setInterval(() => {
      setIndexNotificacao((indexAtual) =>
        indexAtual === notificacoes.length - 1 ? 0 : indexAtual + 1,
      );
    }, 5000);

    return () => clearInterval(intervalo);
  }, [abrirModal, pausarRotacao, notificacoes.length]);

  const buscarUrlBucket = async (idEmpresa) => {
    try {
      const response = await get(`/bucket/bucket/buscar-configuracao/${idEmpresa}`);

      if (response?.status === 200) {
        return response?.data?.urlBucket || "";
      }

      toast.error("Erro ao buscar URL do Bucket. Tente novamente mais tarde.");
      return "";
    } catch (error) {
      console.error(error);
      toast.error("Erro ao buscar URL do Bucket. Tente novamente mais tarde.");
      return "";
    }
  };

  function montarUrlImagem(modal) {
    if (!modal || !modal.imagem) {
      return null;
    }

    const baseUrl = urlsBucket[modal.idEmpresa];
    if (!baseUrl) {
      return null;
    }

    return `${baseUrl}/imagens/MODAL_INFORMATIVO/${modal.imagem}`;
  }

  async function buscarNotificacao() {
    const idUsuario = dadosAuth?.usuarioLogadoDTO?.id;
    try {
      const response = await get(
        `/configuracoes-lojas/modal-informativo/ativos?idUsuario=${idUsuario}`,
      );
      const listaNotificacoes = response?.data?.content || [];

      if (listaNotificacoes.length === 0) {
        return;
      }

      const empresas = [...new Set(listaNotificacoes.map((item) => item.idEmpresa))];

      const urls = await Promise.all(empresas.map((idEmpresa) => buscarUrlBucket(idEmpresa)));

      const urlsPorEmpresa = empresas.reduce((acc, idEmpresa, index) => {
        acc[idEmpresa] = urls[index];
        return acc;
      }, {});

      setUrlsBucket(urlsPorEmpresa);
      setNotificacoes(listaNotificacoes);
      setIndexNotificacao(0);
      setAbrirModal(true);
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Erro ao obter dados de notificações.");
    }
  }

  function obterTamanho(tamanho) {
    switch (tamanho) {
      case "PEQUENO":
        return "sm";
      case "MEDIO":
        return "md";
      case "GRANDE":
        return "lg";
      default:
        return "md";
    }
  }

  function registrarClickNotificacao(notificacaoAtual) {
    post(`/configuracoes-lojas/modal-informativo/acesso/${notificacaoAtual.id}`)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        const message = error.response?.data?.message || "Erro ao registrar clique na notificação.";
        toast.error(message);
        console.error(error);
      });
  }

  function naoExibirNovamente(notificacaoAtual) {
    post(`/configuracoes-lojas/modal-informativo/ocultar/${notificacaoAtual.id}`)
      .then((response) => {
        const novasNotificacoes = notificacoes.filter(
          (notificacao) => notificacao.id !== notificacaoAtual.id,
        );
        setNotificacoes(novasNotificacoes);
        if (novasNotificacoes.length === 0) {
          setAbrirModal(false);
        } else {
          setIndexNotificacao(0);
        }
      })
      .catch((error) => {
        const message = error.response?.data?.message || "Erro ao ocultar a notificação.";
        toast.error(message);
        console.error(error);
      });
  }

  function fecharModal() {
    setAbrirModal(false);
    setPausarRotacao(false);
    document.cookie = `notificacaoLogadoExibir=true`;
  }

  return (
    <GerarModalResponsivo
      ativo={abrirModal}
      apenasModoPopup
      modoPopUpBannerInformativo
      onFechar={() => {}}
      children={() => {
        const notificacaoAtual = notificacoes[indexNotificacao];
        return (
          notificacaoAtual && (
            <div
              onMouseEnter={() => setPausarRotacao(true)}
              onMouseLeave={() => setPausarRotacao(false)}
            >
              <ModalInformativo
                registrarClick={() => {
                  registrarClickNotificacao(notificacaoAtual);
                }}
                naoExibirNovamente={() => {
                  naoExibirNovamente(notificacaoAtual);
                }}
                image={montarUrlImagem(notificacaoAtual)}
                hiperlink={notificacaoAtual.hiperlink}
                descritivoModal={notificacaoAtual.descricao}
                tamanho={obterTamanho(notificacaoAtual.tamanho)}
                totalNotificacoes={notificacoes.length}
                indexNotificacao={indexNotificacao}
                onNavigate={setIndexNotificacao}
                close={fecharModal}
              />
            </div>
          )
        );
      }}
    />
  );
}
